export default "__VITE_ASSET__DQhZ0vT7__"